import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { endpoints, environment } from '@environment';
import {
  AddHouseholdMemberRequest,
  EditHouseholdMemberRequest,
  Household,
  HouseholdMember,
  UpdateHouseholdRequest,
} from '@core/models';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';

@Injectable({ providedIn: 'root' })
export class HouseholdService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.household}`;

  getMine(): Observable<Household> {
    return this.http.get<Household>(this.baseUrl, { context: suppressGlobalErrorFeedback() });
  }

  updateMine(payload: UpdateHouseholdRequest): Observable<Household> {
    return this.http.put<Household>(this.baseUrl, payload, { context: suppressGlobalErrorFeedback() });
  }

  getMembers(): Observable<HouseholdMember[]> {
    return this.http.get<HouseholdMember[]>(`${this.baseUrl}/members`, { context: suppressGlobalErrorFeedback() });
  }

  addMember(payload: AddHouseholdMemberRequest): Observable<HouseholdMember> {
    return this.http.post<HouseholdMember>(`${this.baseUrl}/members`, payload, { context: suppressGlobalErrorFeedback() });
  }

  editMember(
    id: string,
    payload: EditHouseholdMemberRequest
  ): Observable<HouseholdMember> {
    return this.http.put<HouseholdMember>(`${this.baseUrl}/members/${id}`, payload, { context: suppressGlobalErrorFeedback() });
  }

  deleteMember(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/members/${id}`, { context: suppressGlobalErrorFeedback() });
  }
}
